// The "Related guides" list at the end of each article, on the themes the brand
// wants ranked: service history, mileage and buying checks. The polish, road
// noise and dents guides link out to these but are never linked to from here.
// Used by GuideArticlePage.jsx and scripts/prerender-guides.mjs.

import { SERVICE_HISTORY_PATH, hasServiceHistoryPages } from "./serviceHistoryRoutes.js";

const RELATED_BY_BRAND = {
  serviceboss: {
    "how-to-check-car-service-history": ["what-full-service-history-really-means", "manufacturer-service-history-explained", "buying-a-car-privately-checklist"],
    "manufacturer-service-history-explained": ["how-to-check-car-service-history", "what-full-service-history-really-means", "cambelt-changes-and-service-records"],
    "spotting-a-mileage-discrepancy": ["dvsa-mot-data-explained", "manufacturer-service-history-explained", "buying-a-car-privately-checklist"],
    "car-valuations-explained": ["hpi-clear-explained", "spotting-a-mileage-discrepancy", "buying-a-car-privately-checklist"],
    "hpi-clear-explained": ["buying-a-car-privately-checklist", "car-valuations-explained", "spotting-a-mileage-discrepancy"],
    "buying-a-car-privately-checklist": ["how-to-check-car-service-history", "hpi-clear-explained", "what-full-service-history-really-means"],
    "dvsa-mot-data-explained": ["spotting-a-mileage-discrepancy", "manufacturer-service-history-explained", "buying-a-car-privately-checklist"],
    "ev-charging-checks-before-buying": ["buying-a-car-privately-checklist", "manufacturer-service-history-explained", "car-valuations-explained"],
    "what-full-service-history-really-means": ["how-to-check-car-service-history", "manufacturer-service-history-explained", "cambelt-changes-and-service-records"],
    "cambelt-changes-and-service-records": ["what-full-service-history-really-means", "manufacturer-service-history-explained", "buying-a-car-privately-checklist"],
    "car-polish-vs-wax-vs-sealant": ["car-valuations-explained", "buying-a-car-privately-checklist"],
    "how-to-reduce-road-noise-in-car": ["buying-a-car-privately-checklist", "what-full-service-history-really-means"],
    "how-to-remove-car-dents-at-home": ["car-valuations-explained", "buying-a-car-privately-checklist"],
  },
};

// Every ServiceBoss guide also links to the service history check page.
export function pillarLinkFor(brand) {
  return hasServiceHistoryPages(brand.key) ? { href: SERVICE_HISTORY_PATH, label: "Car service history check by registration" } : null;
}

// The linked guides for one article, as { slug, title } in the brand's own URLs.
export function relatedGuidesFor(brand, articleSlug) {
  const key = String(articleSlug).replace(/^\/guides\//, "").replace(/\/$/, "");
  const related = RELATED_BY_BRAND[brand.key]?.[key] || [];
  return related
    .map((slug) => (brand.guides || []).find((guide) => guide.slug === `/guides/${slug}`))
    .filter(Boolean);
}
